import { Post as PostBase } from '@wellesley/openapi'

type Post = PostBase & { pinnedAt?: string | null }

const getPinnedAtMs = (p: Post) =>
  p.pinnedAt ? new Date(p.pinnedAt).getTime() : 0

const sortByPinnedAtDesc = (a: Post, b: Post) =>
  getPinnedAtMs(b) - getPinnedAtMs(a)

const sortRepliesByPinnedAt = (replies: Post[]): Post[] => {
  const firstLevelPinned = replies
    .filter((p) => p.pinned && p.path.length === 1)
    .sort(sortByPinnedAtDesc)

  const highlightCopies = replies
    .filter((p) => p.pinned && p.path.length > 1)
    .sort(sortByPinnedAtDesc)

  const unpinned = replies.filter((p) => !p.pinned)

  return [...firstLevelPinned, ...highlightCopies, ...unpinned]
}

export default sortRepliesByPinnedAt
